import styled from "styled-components";
import { Colors } from "../../../values/colors";

export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid ${Colors.ultraLightGray};
  background: #fff;
`;

export const BackBtn = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const SurveyTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0;
`;

export const EmbedContent = styled.div`
  position: relative;
  min-height: 600px;
  width: 100%;
`;

export const DownloadBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 150;
  animation: backdropFadeIn 0.2s ease-in-out;

  @keyframes backdropFadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
`;
